export const DOMAIN_API_MAP: Record<string, string> = {
    'eatobox.ru': 'https://eatobox-api.ru',
    '5harmonies.ru': 'https://api.5harmonies.ru',
    'ritzipcrm.com': 'https://ritzipcrm-api.com',
    'adwanto.com': 'https://adwanto-api.com',
    'animocrm.ru': 'https://animocrm-api.ru',
    'flowerbloom-api.ru': 'https://flowerbloom-api.ru',
    'kvorum.docacrm.ru': 'https://kvorum.docacrm.com',
    'terzdrav-slyx.docacrm.ru': 'https://terzdrav-slyx.docacrm.com',

    'admin.eatobox.ru': 'https://v2.eatobox.ru',

    'doca.ru': 'https://api.doca.ru',
    'crm.astragreen.shop': 'https://api.astragreen.shop/',
}

export const MEOWBOX_SUBDOMAIN_MAP: Record<string, string> = {
    'oxcrm': 'https://crm-api.meowbox.ru',
    'ritzipcrm': 'https://ritzip-api.meowbox.ru',
    'maxdetal-crm': 'https://maxdetal-api.meowbox.ru',
    'lease2own-crm': 'https://lease2own-api.meowbox.ru',
    'commercefoods-crm': 'https://commercefoods-api.meowbox.ru',
}
